<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: copy.vue
  - Created by: ChanYing
  - Create Date: 2023-11-02 18:21
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <div class="deleteIcon" @mouseover="isHover = true" @mouseout="isHover = false" @click="copy">
    <svg class="ztn-icon-sm" width="16" height="16" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M13.1673 14.4998H5.83398V5.1665H13.1673M13.1673 3.83317H5.83398C5.48036 3.83317 5.14122 3.97365 4.89118 4.22369C4.64113 4.47374 4.50065 4.81288 4.50065 5.1665V14.4998C4.50065 14.8535 4.64113 15.1926 4.89118 15.4426C5.14122 15.6927 5.48036 15.8332 5.83398 15.8332H13.1673C13.5209 15.8332 13.8601 15.6927 14.1101 15.4426C14.3602 15.1926 14.5007 14.8535 14.5007 14.4998V5.1665C14.5007 4.81288 14.3602 4.47374 14.1101 4.22369C13.8601 3.97365 13.5209 3.83317 13.1673 3.83317ZM11.1673 1.1665H3.16732C2.8137 1.1665 2.47456 1.30698 2.22451 1.55703C1.97446 1.80708 1.83398 2.14622 1.83398 2.49984V11.8332H3.16732V2.49984H11.1673V1.1665Z"
          :fill="isHover ? 'var(--base-primary-3)' : 'var(--body-aux-2)'"/>
    </svg>
  </div>
</template>

<script>
import {MessageType, ztnMessage} from "@/commons/utils/ZtnMessage";
import StringUtil from "@/commons/utils/StringUtil";

export default {
  name: "copy",
  props: {
    value: String
  },
  data() {
    return {
      isHover: false,
    }
  },
  methods: {
    copy() {
      if (this.value) {
        StringUtil.copyToClipboard(this.value).then(() => {
          ztnMessage({message: this.$t('data.internet_access.prompt.copy_text'), type: MessageType.success});
        });
      }
    }
  }
}
</script>
<style scoped>
.deleteIcon {
  cursor: pointer;
}
</style>